@for (segment of segments(); track $index) {
  @if (segment.isPlaceholder) {
    <span class="material-placeholder">{{ segment.display }}</span>
  } @else {
    <span>{{ segment.display }}</span>
  }
}
